import { useCallback, useState } from "react";

import { CheckIcon, CopyIcon } from "@phosphor-icons/react";

import Button, { ButtonSize, ButtonVariant } from "../buttons/Button";
import FlexWrapper, { AlignItems } from "../containers/FlexWrapper";
import { InputSize } from "./Input";
import TextInput from "./TextInput";

const INPUT_SIZE_TO_BUTTON_SIZE: Record<InputSize, ButtonSize> = {
  [InputSize.SMALL]: ButtonSize.SMALL,
  [InputSize.MEDIUM]: ButtonSize.MEDIUM,
  [InputSize.LARGE]: ButtonSize.LARGE,
};

export interface CopyInputProps {
  value: string;
  label?: string;
  labelTooltip?: string | React.ReactNode;
  size?: InputSize;
  width?: number | string;
  fillWidth?: boolean;
  isMonospace?: boolean;
}

const CopyInput = ({
  value,
  label,
  labelTooltip,
  size = InputSize.MEDIUM,
  width,
  fillWidth,
  isMonospace = false,
}: CopyInputProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    void navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [value]);

  return (
    <FlexWrapper alignItems={AlignItems.END} gap={8} fillWidth={fillWidth}>
      <TextInput
        label={label}
        labelTooltip={labelTooltip}
        value={value}
        onChange={() => {}}
        size={size}
        width={width}
        fillWidth={fillWidth}
        isDisabled
        isMonospace={isMonospace}
      />
      <Button
        icon={copied ? CheckIcon : CopyIcon}
        variant={ButtonVariant.SECONDARY}
        size={INPUT_SIZE_TO_BUTTON_SIZE[size]}
        onClick={handleCopy}
      />
    </FlexWrapper>
  );
};

CopyInput.displayName = "CopyInput";

export default CopyInput;
